import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import GenericEmbedSchema from 'sitemodel/schema/components/GenericEmbedSchema'
import { ComponentPropsType } from 'sitemodel/shared/types/sitemodel.type'

export type ParamMappingSource = 'state' | 'url' | 'static'
export interface ParamMappingConfig {
  source: ParamMappingSource
  key?: string
  value?: unknown
}

export interface ResolveParamsConfig {
  paramsMapping?: Record<string, ParamMappingConfig>
  sitemodelState?: ComponentPropsType
  searchParams?: URLSearchParams
}

export type GenericEmbedComponentProps = schemaToReactType<
  typeof GenericEmbedSchema
>

export const GenericEmbedComponentTypeGuard =
  schemaToTypeGuard(GenericEmbedSchema)
